export const AUTH_START = 'AUTH_START';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const SET_AUTH_REDIRECT_PATH = 'SET_AUTH_REDIRECT_PATH';

export const PARTNER_CHANGE = 'PARTNER_CHANGE'

export const CHANGE_APPOINTMENTS = 'CHANGE_APPOINTMENTS'
